import * as React from "react";
import { isEmpty } from "lodash-es";
interface Props {
  title: string | React.ReactNode;
  id: number;
  accordionId: string;
  skipFirst?: boolean;
  onCollapse?: (expanded: boolean) => void;
  bottomText?: string | React.ReactNode;
  children?: React.ReactNode;
}

export const CollapsibleContactsCard: React.FC<Props> = ({
  id,
  title,
  accordionId,
  bottomText,
  children,
  onCollapse,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const handleClick = () => {
    const next = !isOpen;
    setIsOpen(next);
    onCollapse?.(next);
  };

  return (
    <div className="card mb-2 border-top p-md-3 p-1">
      <div className="ps-0 card-header" id={`contactCardHeading${id}`}>
        <button
          id={`dataItem${id}`}
          type="button"
          className={"btn btn-flat-primary justify-content-start ps-0 ms-2 mw-100 text-truncate collapsed"}
          data-toggle="collapse"
          data-target={`#contactCardCollapse${id}`}
          aria-expanded={isOpen}
          aria-controls={`contactCardCollapse${id}`}
          onClick={handleClick}
        >
          <i className="icon icon-sm ms-0 me-2 d-inline-block">
            {isOpen ? "keyboard_arrow_down" : "keyboard_arrow_right"}
          </i>
          <span className="text-primary fs-4 fw-bolder d-inline-block">{title}</span>
        </button>
      </div>
      <div
        id={`contactCardCollapse${id}`}
        className={`collapse${isOpen ? " show" : ""}`}
        aria-labelledby={`contactCardHeading${id}`}
        data-parent={`#${accordionId}`}
      >
        <div className="card-body pt-0 ps-xs-0">{children}</div>
        {!isEmpty(bottomText) && <>{bottomText}</>}
      </div>
    </div>
  );
};
